import { LevelProps } from '../../../Types'
import { LEVEL_CARDS } from '../../../Constants'
import { LevelPage } from '../../LevelPage'

export const WhatsApp = (props: LevelProps) => {
  return <LevelPage {...props} imgScale={0.45} textWidth="40%" cards={LEVEL_CARDS.L3.WHATSAPP} />
}
